import React from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsify } from '../utils/url';
import HeroPreview from './HeroPreview';

export default function Hero({ movie }) {
  const navigate = useNavigate();
  if (!movie) return null;
  const bg = httpsify(movie.heroUrl || movie.thumbUrl);
  return (
    <header
      className="cs-hero"
      style={bg ? { backgroundImage: `url(${bg})` } : undefined}
    >
      <HeroPreview movie={movie} />
      <div className="cs-hero-content">
        <div className="cs-hero-meta">
          {[movie.location, movie.year].filter(Boolean).join(' · ')}
        </div>
        <div className="cs-hero-titlerow">
          <button
            className="cs-hero-play"
            title={`Play ${movie.title}`}
            onClick={() => navigate(`/watch/${movie.id}`)}
          >
            ▶
          </button>
          <h1>{movie.title}</h1>
        </div>
        {movie.synopsis && <p>{movie.synopsis}</p>}
      </div>
    </header>
  );
}
